module.exports = "<!--For routing purpose.-->\r\n<!-- <app-layout *ngIf=showLayout></app-layout>\r\n<router-outlet *ngIf=!showLayout></router-outlet> -->\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main